import React from 'react';
import { GamingWidgetContentWrapper, GamingWidgetContentHeader, GamingWidgetContentText } from './styled-components';
export const GamingWidgetContent = ({ headerTitle, text }) => {
    return (React.createElement(GamingWidgetContentWrapper, null,
        React.createElement("div", null,
            React.createElement(GamingWidgetContentHeader, { "data-testid": "HeaderTitle" }, headerTitle),
            React.createElement(GamingWidgetContentText, { "data-testid": "SubtitleText" }, text))));
};
